<div class="w-full text-red-600" *ngIf="control && control.dirty">
  <p *ngFor="let error of getErrors()">
    @if(getSuppressMessage(error); as value)
    {
      {{ '::' + value | abpLocalization }}
    }
    @else{
    {{ '::' + 'validation:' + error | abpLocalization }}
    }
  </p>
</div>
